"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageResponses = void 0;
var common_1 = require("../common");
var LanguageResponses;
(function (LanguageResponses) {
    var ListLanguagesResponse = /** @class */ (function (_super) {
        __extends(ListLanguagesResponse, _super);
        function ListLanguagesResponse(
        /**
         * List of languages
         */
        languages, 
        /**
         * Pagination
         */
        pagination, 
        /**
         * Response
         */
        response, isDeveloperMode) {
            var _this = _super.call(this, response, isDeveloperMode) || this;
            _this.languages = languages;
            _this.pagination = pagination;
            return _this;
        }
        return ListLanguagesResponse;
    }(common_1.BaseKontentResponseStandardDebug));
    LanguageResponses.ListLanguagesResponse = ListLanguagesResponse;
})(LanguageResponses = exports.LanguageResponses || (exports.LanguageResponses = {}));
//# sourceMappingURL=responses.js.map